import React from "react";

import * as Styles from "./styles";

interface Props {
  open: boolean;
  isRight?: "absolute" | "relative";
  height?: number | "auto";
  width?: number | "auto";
  setOpenModal: (val: boolean) => void;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalCommon: React.FC<Props> = (props) => {
  return (
    <Styles.Modal
      disableBackdropClick
      PaperProps={{
        style: {
          borderRadius: 8,
          position: props?.isRight ? "absolute" : "relative",
          top: props?.isRight ? 40 : 0,
          right: props?.isRight ? 10 : 0,
          display: "flex",
          height: props?.height || "auto",
          width: props?.width || "auto",
        },
      }}
      open={props?.open}
      onClose={(event, reason) => {
        props?.setOpenModal(false);
        props?.onClose();
      }}
    >
      {props?.children}
    </Styles.Modal>
  );
};

export default ModalCommon;
